import {
  ApiUpdateMyWishlistFailedAction,
  ApiUpdateMyWishlistSucceededAction,
  apiUpdateMyWishlistFailedType,
  apiUpdateMyWishlistRequested,
  apiUpdateMyWishlistSucceededType
} from '@spa/lib/store/api/wishlists/updateMyWishlistApi';
import {
  UpdateMyWishlistRequestedAction,
  updateMyWishlistFailed,
  updateMyWishlistSucceeded
} from '@spa/lib/store/wishlists/wishlistsSlice';
import generateActionId from '@spa/lib/generateActionId';
import { put } from 'typed-redux-saga';
import waitForSucceededOrFailedAction from '@spa/lib/store/sagas/session/waitForSucceededOrFailedAction';

function* updateMyWishlistSaga({
  payload: { actionId: requestedActionId, input }
}: UpdateMyWishlistRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(apiUpdateMyWishlistRequested({ actionId, parentActionId: requestedActionId, input }));

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiUpdateMyWishlistSucceededType,
    typeof apiUpdateMyWishlistFailedType,
    ApiUpdateMyWishlistSucceededAction,
    ApiUpdateMyWishlistFailedAction
  >(actionId, apiUpdateMyWishlistSucceededType, apiUpdateMyWishlistFailedType);

  if (waitResult.type === 'succeeded') {
    yield* put(updateMyWishlistSucceeded({ requestedActionId, input }));
  } else {
    yield* put(
      updateMyWishlistFailed({
        errors: waitResult.action.payload.errors,
        requestedActionId
      })
    );
  }
}

export default updateMyWishlistSaga;
